import React from 'react';
import Head from 'next/head';

const MetaData = ({ seoInfo }) => {
  if (!seoInfo) {
    return null;
  }
  const seoInfoKeys = seoInfo ? Object.keys(seoInfo) : [];
  if (seoInfoKeys.length === 0) {
    return null;
  }
  /* eslint-disable camelcase */
  const {
    /* basics first level values */
    title,
    description,
    keywords,
    robots,
    canonical,
  } = seoInfo;
  /* modifications dates */
  const { dateModified, datePublished, dateCreated } = seoInfo;
  /* rrss_fb */
  const { rrss_fb } = seoInfo;
  const fbTitle = rrss_fb && rrss_fb['og:title'] ? rrss_fb['og:title'] : '';
  const fbType = rrss_fb && rrss_fb['og:type'] ? rrss_fb['og:type'] : '';
  const fbImage = rrss_fb && rrss_fb['og:image'] ? rrss_fb['og:image'] : '';
  const fbUrl = rrss_fb && rrss_fb['og:url'] ? rrss_fb['og:url'] : '';
  const fbDescription =
    rrss_fb && rrss_fb['og:description'] ? rrss_fb['og:description'] : '';
  const fbSiteName = rrss_fb && rrss_fb.site_name ? rrss_fb.site_name : '';
  /* x aki vamos */
  const { search_engines_verification } = seoInfo;
  /* microdata */
  const { microdata_product, microdata_website, breadcrums, page_name, product_name } = seoInfo;

  
  return (
    <Head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
      {/* basics first level values */}
      {title && <title>{title}</title>}
      <meta id="page_name" name="page_name" content={page_name || ''} />
      <meta id="product_name" name="product_name" content={product_name || ''} />
      <meta id="context_seo_meta" name="description" content={description || ''} />
      {keywords && <meta name="keywords" content={keywords} />}
      {robots && <meta name="Robots" content={robots} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta name="author" content="Movistar" />
      <meta name="owner" content="Movistar" />
      {/* modifications dates */}
      {dateModified && <meta itemProp="dateModified" content={dateModified} />}
      {datePublished && (
        <meta itemProp="datePublished" content={datePublished} />
      )}
      {dateCreated && <meta itemProp="dateCreated" content={dateCreated} />}
      {/* rrss_fb */}
      {fbTitle && <meta property="og:title" content={fbTitle} />}
      {fbImage && <meta property="og:image" content={fbImage} />}
      {fbType && <meta property="og:type" content={fbType} />}
      {fbUrl && <meta property="og:url" content={fbUrl} />}
      {fbDescription && (
        <meta property="og:description" content={fbDescription} />
      )}
      {fbSiteName && <meta property="og:site_name" content="Movistar" />}
      {/* search_engines_verification */}
      {search_engines_verification &&
        search_engines_verification.length > 0 &&
        search_engines_verification.map((item) => {
          const keyName = Object.keys(item)[0] || '';
          const value = item[keyName] || '';
          return (
            <meta key={`${keyName}-${value}`} name={keyName} content={value} />
          );
        })}
      {microdata_product && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{__html:  JSON.stringify(microdata_product) }}
        />
      )}
      {microdata_website && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{__html:  JSON.stringify(microdata_website) }}
        />
      )}
      {breadcrums && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{__html:  JSON.stringify(breadcrums) }}
        />
      )}
    </Head>
  );
}

export default MetaData;